import { useActiveVariant } from './useActiveVariant';
import { ppData } from '../configs/ppData.config';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_LAYOUT } from '../constants/searchParamKeys';
export const useActiveOrFirstVariant = (searchParams = useSearchParams()[0]) => {
    const layout = searchParams.get(SEARCH_PARAM_KEY_LAYOUT) ?? '';
    return useActiveVariant(searchParams) ??
        ppData.variants.find(({ optionValues }) => {
            return optionValues.includes(layout);
        }) ??
        ppData.variants[0];
};
